import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, cloneDeep, get } from 'lodash';
import Box from '../../common/Box';
import ReactSelect from '../../common/ReactSelect';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChartWithAnnotations from '../../widgets/charts/types/LineChartWithAnnotations';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import DateGroupSelector from '../result/DateGroupSelector';
import CSV from '../../../helpers/CSVExport';
import Tooltip from "../../common/Tooltip";
import ReactTable from 'react-table';
import ModeSelect from '../../common/ModeSelect';
import { youtubeTimeseriesSettings } from './YoutubeTimeseries/Settings'; 
import { youtubeActions } from '../../../data/actions/youtube';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');


class YoutubeTimeseries extends React.Component {
	
	nullElement = {vend_id: 0, value: 'all', label: 'All'}
	
	constructor(props) {
		super(props);
		this.state = {
			mode: props.defaultMode || 'line',
			dateGroup: null
		}
		
		this.setChartMode = this.setChartMode.bind(this);
		this.setDateGroup = this.setDateGroup.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
	}

	setDateGroup(dateGroup) {
        this.setState({dateGroup}, ()=>{
            this.props.getYoutubeTimeseries(this.props.filtered, this.state.dateGroup);
        });
    }

	
	setChartMode(mode){
		this.setState({mode});
		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
		
	}
	
	renderToolbar(data){
		const options = [
			{icon: tableSvg, value: 'table', label: "Table"},
			{icon: barSvg, value: 'bar', label: "Bar Chart"},
			{icon: pieSvg, value: 'pie', label: "Donut Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
		];

		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-holder">
		<div className="ibox-actions">
			<div className="ibox-icon-holder mode-select">
				<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
			</div>
            <a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		</div>
		</div>)

		return toolbar;
	}
	
    exportToCsv(){
        const filename = CSV.CSVHeader('youtube_views', '', this.props.filter.global, this.props.parentEntityTitle); 
        return CSV.CSVExport(this.props.youtube.timeline.tableData, {filename}, 'youtube_views');
    }

	
	
	componentDidMount() {
		this.props.getYoutubeTimeseries(this.props.filtered, this.state.dateGroup);
	}
	
	componentWillReceiveProps(nextProps){
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				this.props.getYoutubeTimeseries(this.props.filtered, this.state.dateGroup);
			}                
		}
		if(nextProps.filtered && !isEqual(nextProps.filtered, this.props.filtered)) {
			this.props.getYoutubeTimeseries(nextProps.filtered, this.state.dateGroup);
		} 
	}
	
	render (){  
		const {timeline: youtubeTimeseries, loading: youtubeTimeseriesLoading, table} = this.props.youtube,
			widgetTitle = `YouTube Views`;
		const { mode } = this.state;	
		let pieLabels, pieDataset, tableData;
	

		let chartData = cloneDeep(youtubeTimeseries); 
		if(chartData) {
			chartData.datasets = chartData.datasets.filter(dataset => (mode == 'line' ? dataset.total : !dataset.total));
			pieLabels = chartData.pieLabels
			pieDataset = chartData.pieDataset;
			tableData = chartData.tableData;
		}

		let { shadowChartProps } = this.props;
		if(shadowChartProps){
			shadowChartProps.shadowChart = true;
		}     

		let milestonesItems = get(this.props.milestones, 'entities.mixed.tableItems', [])
		return <Box title={widgetTitle} toolbar={this.renderToolbar()} spinnerEnabled={youtubeTimeseriesLoading} hasTooltip={false} >
			{(chartData && chartData.datasets) && 
				<React.Fragment>
				{(tableData && mode == 'table' ) && <ReactTable
					className="simple-table"
					data={tableData}
					columns={youtubeTimeseriesSettings.settingsForTable()}
					showPagination={true}
					defaultSortDesc={false}
					defaultSorted={this.state.sorted}
					pageSize={10}                
				/>}

				{ mode == 'line' && <div className="chart-block">
					{chartData.datasets && <LineChartWithAnnotations milestones={milestonesItems} data={chartData} dateGroup={this.state.dateGroup ? this.state.dateGroup : this.props.filter.global.range} period={this.state.period} shadowChartProps={shadowChartProps}  filteredLogVendors={['youtube']} />}
				</div>}
				{ mode == 'bar' && <div className="chart-block">
					{chartData.datasets && <StackedBarChart milestones={milestonesItems} data={chartData} dateGroup={this.state.dateGroup ? this.state.dateGroup : this.props.filter.global.range} period={this.state.period} shadowChartProps={shadowChartProps} />}
				</div>}		
				{ mode == 'pie' && <div className="chart-block">
					{pieDataset && <DoughnutChart data={{labels: pieLabels, datasets: pieDataset}}  shadowChartProps={shadowChartProps} />}
				</div>}		
				</React.Fragment>
			}
		</Box>;
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
	} 
}

function mapStateToProps(state) {
	return {
		youtube: state.youtube,
		filter: state.filter,
		milestones: state.milestones
	} 
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		getYoutubeTimeseries: (filtered, dateGroup) => {
			return dispatch(youtubeActions.getStreamsStats(filtered, dateGroup));
		} 
	} 
}



export default connect(mapStateToProps, mapDispatchToProps)(YoutubeTimeseries);